'use client'

import { Dialog } from '@acko/dialog'
import { Drawer } from '@acko/drawer'
import { Button } from '@acko/button'
import { Typography } from '@acko/typography'
import { useEffect, useState } from 'react'
import { BikeRegistrationForm, type BikeRegistrationFormProps } from './BikeRegistrationForm'
import styles from './page.module.css'

export type BikeRegistrationInputModalPresentation = 'modal' | 'bottom-sheet'

interface BikeRegistrationInputModalProps {
  onClose: () => void
  onNewBikeClick: () => Promise<void> | void
  presentation?: BikeRegistrationInputModalPresentation
  registrationFormProps: BikeRegistrationFormProps
  show: boolean
  viewModel: any
}

export const BikeRegistrationInputModal = ({
  onClose,
  onNewBikeClick,
  registrationFormProps,
  show,
  viewModel,
}: BikeRegistrationInputModalProps) => {
  const [isMobile, setIsMobile] = useState(false)
  const newFlowBanner = viewModel?.newFlowBanner ?? {}

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  const handleNewBikeKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      void onNewBikeClick()
    }
  }

  const widgetCards = (
    <>
      <BikeRegistrationForm {...registrationFormProps} heading={undefined} />
      <div
        className={`${styles.newBikeCard} group transition-all duration-200 hover:shadow-lg`}
        role="button"
        tabIndex={0}
        onKeyDown={handleNewBikeKeyDown}>
        <div className="flex flex-col gap-8">
          <Typography scale="xl" emphasis="medium" as="h3" color="primary">
            {newFlowBanner?.heading}
          </Typography>
          <Typography scale="base" color="secondary">
            {newFlowBanner?.subHeading}
          </Typography>
        </div>
        <div className="flex items-center justify-between gap-12 w-full">
          <div className="relative w-full">
            <Button
              onClick={() => {
                void onNewBikeClick()
              }}
              variant="secondary"
              size="lg"
              className="w-full">
              {' '}
              Get quote{' '}
            </Button>
          </div>
        </div>
      </div>
    </>
  )

  const title = registrationFormProps.heading ?? "Let's insure your bike"

  if (isMobile) {
    return (
      <Drawer
        open={show}
        onClose={onClose}
        side="bottom"
        title={title}
        className="!max-h-none [&_.acko-drawer-title]:[font-size:var(--font-heading-lg-size)]! [&_.acko-drawer-title]:[line-height:var(--font-heading-lg-line)]! [&_.acko-drawer-title]:[letter-spacing:var(--font-heading-lg-spacing)]! [&_.acko-drawer-title]:[font-weight:var(--font-heading-lg-weight)]!">
        <div className="flex flex-col gap-20">{widgetCards}</div>
      </Drawer>
    )
  }

  return (
    <Dialog
      open={show}
      onClose={onClose}
      title={title}
      className="!max-w-[520px] [&_.acko-dialog-title]:text-[var(--font-heading-lg-size)] [&_.acko-dialog-title]:leading-[var(--font-heading-lg-line)] [&_.acko-dialog-title]:tracking-[var(--font-heading-lg-spacing)] [&_.acko-dialog-title]:[font-weight:var(--font-heading-lg-weight)]">
      <div className="flex flex-col gap-20">{widgetCards}</div>
    </Dialog>
  )
}
